import ReactDOM from "react-dom";

const ConfirmBox = ({ message, onClick, closeModal }) => {
  const handleSubmit = () => {
    onClick();
    closeModal();
  };
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="assign-checker-modal-content">
        <div className="modal-header"></div>
        <div className="modal-body clearfix">
          <label id="confirm_submit_lable">{message}</label>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn rc-btn_primary"
            onClick={handleSubmit}
          >
            Ok
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ConfirmBox;
